module.exports = __webpack_public_path__ + "static/media/alert.184b1553.svg";